"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMock = void 0;
var isMock = window && window.location.href.split('#')[0].indexOf('mock=1') !== -1;
exports.isMock = isMock;